import { useContext, useEffect, useState } from "react";
import CustomInput from "../components/input/CustomInput";
import { UserContext } from "../components/context/UseContext";
import { AppLayout } from "../layout/AppLayout";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import BoxGames from "../components/homeUI/BoxGames";
import { Search } from "../components/svg/GeneralIcons";
import { useGetAllCampaigns } from "../api/campaigns/getAllCampaigns";
import { CardLoader } from "../components/loader/CardLoader";
import { Avatar } from "../components/Avatar";
import SEO from "../components/SEO/SEO";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
    partialVisibilityGutter: 20,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    partialVisibilityGutter: 20,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    partialVisibilityGutter: 20,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2,
    partialVisibilityGutter: 20,
  },
};

// const arenas = [
//   {
//     name: "Word Trivia",
//     bg: "linear-gradient(215.13deg, #FF0084 -3.92%, #AF0014 95.77%)",
//   },
//   {
//     name: "Arcade",
//     bg: "linear-gradient(215.13deg, #00B3FF -3.92%, #0040AF 95.77%)",
//   },
//   {
//     name: "Adventure",
//     bg: "linear-gradient(215.13deg, #00FBFF -3.92%, #75AF00 95.77%)",
//   },
//   {
//     name: "Puzzle",
//     bg: "linear-gradient(215.13deg, #FFBB2A -3.92%, #E28605 95.77%)",
//   },
//   {
//     name: "Arcade",
//     bg: "linear-gradient(215.13deg, #00FBFF -3.92%, #75AF00 95.77%)",
//   },
//   {
//     name: "Strategy",
//     bg: "linear-gradient(215.13deg, #00FBFF -3.92%, #1A8169 95.77%)",
//   },
//   {
//     name: "Board",
//     bg: "linear-gradient(215.13deg, #E100FF -3.92%, #3700AF 95.77%)",
//   },
//   {
//     name: "Card",
//     bg: "linear-gradient(215.13deg, #FFBB2A -3.92%, #E28605 95.77%)",
//   },
// ];

function Gaming() {
  const { token, profile } = useContext(UserContext);
  const navigate = useNavigate();
  const { getCampaigns, campaigns, loading } = useGetAllCampaigns();
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [debouncedValue, setDebouncedValue] = useState("");
  useEffect(() => {
    getCampaigns(token, "", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (campaigns) {
      if (debouncedValue) {
        const filtered = campaigns.filter((campaign) =>
          campaign.title?.toLowerCase().includes(debouncedValue.toLowerCase()),
        );
        setFilteredData(filtered);
      } else {
        setFilteredData(campaigns);
      }
    }
  }, [campaigns, debouncedValue]);

  // Can turn to a debounce hook
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(search);
    }, 600);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  return (
    <AppLayout>
      <SEO
        title="Search Games - Find Your Perfect Challenge on Arena"
        description="Discover and search through Arena's extensive catalog of games. From word trivia to RMC world, find the perfect game to match your skills and win amazing rewards."
        keywords="search games, arena catalog, word trivia, RMC world, gaming categories, find games, browse games"
        url="/search"
      />
      <div className="flex items-center justify-between gap-4 px-4 pt-10">
        <p className="text-2xl font-semibold text-black">Search</p>
        {profile?.profile_image ? (
          <div
            onClick={() => navigate("/settings/profile")}
            className="p-0.5 border-gradient rounded-full w-fit cursor-pointer"
          >
            <img
              className="w-10 h-10 object-cover rounded-full"
              src={profile?.profile_image}
              alt="Profile_image"
              loading="lazy"
            />
          </div>
        ) : (
          <Avatar
            onClick={() => navigate("/settings/profile")}
            firstName={profile?.first_name}
            lastName={profile?.last_name}
          />
        )}
      </div>
      <div className="px-4">
        <CustomInput
          leadingIcon={<Search />}
          value={search}
          onchange={(e) => setSearch(e.target.value)}
          placeholder="Enter a game name"
          type="text"
          className={
            "!bg-transparent placeholder:!text-[#0000004D] !border-none !rounded-none !shadow-none"
          }
        />
      </div>
      <div className="py-9">
        {loading ? (
          <>
            <h4 className="text-xl px-4 font-bold">Suggested</h4>
            <CardLoader />
          </>
        ) : filteredData.length === 0 ? (
          <div className="flex justify-center items-center h-[20vh] flex-col gap-2">
            <p className="tracking-tighter text-xl font-semibold text-black mx-0 text-center">
              {debouncedValue
                ? `No results found for "${debouncedValue}"`
                : "No suggestions yet"}
            </p>
            <p className="text-xs font-medium mt-1 text-black w-full max-w-[300px] text-center">
              {debouncedValue
                ? "Try searching with different keywords or browse our full catalog"
                : "We're working on finding the perfect games for you. Check back soon or explore our catalog!"}
            </p>
          </div>
        ) : (
          <>
            <h4 className="text-xl px-4 font-bold">Suggested</h4>
            <Carousel
              autoPlay={filteredData.length > 2 ? true : false}
              responsive={responsive}
              arrows={false}
              partialVisible={true}
              ssr={true}
              infinite={filteredData.length > 2 ? true : false}
              className={clsx(filteredData.length > 1 && "-ml-10", "mt-5")}
            >
              {filteredData?.map((x, i) => (
                <BoxGames x={x} key={i} />
              ))}
            </Carousel>
          </>
        )}
        {/* <h4 className="text-xl px-4 font-bold mt-7">Browse Categories</h4> */}
        {/* <div className="mt-5 grid grid-cols-12 gap-4 mb-10 px-4">
          {arenas.map((x, i) => {
            return (
              <Arenas
                key={i}
                x={x}
                bg={arenas[i % arenas.length].bg}
                isCategory
              />
            );
          })}
        </div> */}
      </div>
    </AppLayout>
  );
}

export default Gaming;
